// extracted by mini-css-extract-plugin
module.exports = {"wide":"SubscribeInfo_wide__10-8E"};